import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Switch,
  TextField,
  IconButton,
  Button,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  makeStyles,
  CircularProgress,
  Typography,
  Grid,
} from "@material-ui/core";

import StyledButton from "../../../common/models/Button";
import { Cancel, Save } from "@material-ui/icons";
import { appUrl } from "../../../../utils/config";
import axios from "axios";
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from "@material-ui/icons/Cancel";
import DeleteIcon from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";

const useStyles = makeStyles((theme) => ({
  table: {
    backgroundColor: "#fff",
    border: "1px solid #ddd",
    width: "950px",
  },
  footerContainer: {
    marginTop: theme.spacing(3),
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  footer: {
    display: "flex",
    justifyContent: "flex-end",
    gap: theme.spacing(2),
  },
  saveButton: {
    backgroundColor: "#EC6535",
    color: "#fff",
    borderRadius: "20px",
    // padding: "8px 24px",
    textTransform: "none",
    width: "12rem",
    fontSize: "1rem",
    fontWeight: 550,
    cursor: "pointer",
    // paddingLeft:"3rem",
    // paddingRight:"3rem",
    paddingTop: "0.35rem",
    paddingBottom: "0.35rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "5rem",
    "&:hover": {
      backgroundColor: "#993d13",
    },
  },
  backButton: {
    backgroundColor: "#707070",
    color: "#fff",
    borderRadius: "20px",
    // padding: "8px 24px",
    textTransform: "none",
    width: "12rem",
    fontSize: "1rem",
    fontWeight: 550,
    cursor: "pointer",
    // paddingLeft:"3rem",
    // paddingRight:"3rem",
    paddingTop: "0.35rem",
    paddingBottom: "0.35rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "5rem",
    "&:hover": {
      backgroundColor: "#4d4d4d",
    },
  },
  inlineActions: {
    display: "flex",
    flexDirection: "column",
    marginLeft: "8px",
    gap: "4px",
  },
  iconBtn: {
    padding: "4px",
  },
  addButton: {
    marginTop: theme.spacing(2),
    backgroundColor: "#fff",
    color: "#000",
    borderRadius: 20,
    padding: "6px 16px",
    textTransform: "none",
    fontWeight: 600,
    border: "1px solid #000",
    display: "flex",
    alignItems: "center",
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  },
  deleteIcon: {
    color: "red", // Set the color to red
    "&:hover": {
      color: "#d32f2f", // Darker red on hover
    },
  },
  modalityBoxWrapper: {
    display: "flex",
    alignItems: "flex-start",
  },
  containerBox: {
    display: "flex",
    alignItems: "center",
    border: "1px solid #ccc",
    borderRadius: 4,
    padding: "4px 8px",
    backgroundColor: "#fff",
    maxWidth: 250,
  },
  textField: {
    flexGrow: 1,
    "& .MuiInputBase-input": {
      padding: "6px 8px",
    },
  },

  inlineActions: {
    display: "flex",
    flexDirection: "column",
    marginLeft: 8,
  },
  iconBtn: {
    padding: 6,
  },
  iconBtn: {
    padding: 6,
    color: "#000",
  },
  addIconCircle: {
    width: "24px",
    height: "24px",
    borderRadius: "50%",
    border: "2px solid #000",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: theme.spacing(1),
    fontSize: "16px",
    fontWeight: 600,
  },
  inlineActions: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  productCellWrapper: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
  },
}));

const ManufacturingFacilityTypeTab = (props) => {
  const { addSponsorList, rowData,rowNetwork,updateNetworkData } = props;
  const classes = useStyles();
  const [facilityTypes, setFacilityTypes] = useState([]); // Facility types list
  const [newRow, setNewRow] = useState({
    id: null,
    name: "",
    products: [],
    selected: false,
    isNew: true,
  }); // New row state
  const [loading, setLoading] = useState(false); // Loading state
  const [error, setError] = useState(null); // Error state
  const [productOptions, setProductOptions] = useState([]);
  const [isUpdated, setIsUpdated] = useState(false); // Initialize as false
  const [errorMessage, setErrorMessage] = useState("");
  // Add savingStates state
  const [savingStates, setSavingStates] = useState({});
  const [isSaving, setIsSaving] = useState(false); // Track save & next button loading

   const network=addSponsorList?.data?.network || rowNetwork;
   const networkUrl=updateNetworkData?.ecosystemUrl || rowData?.networkURL;

  const fetchFacilityTypes = async () => {
    try {
      setLoading(true); // Show loading indicator
      setError(null); // Clear any previous errors

      const url = `${networkUrl}/Pharma%20Contract%20Manufacturing/${network}/Pharma%20Co/Admin/fetchFacilityTypes/false`;
      const response = await axios.get(url);

      const data = response?.data?.data;


      if (data?.status === true || data?.status === "true") {
        const list = data.facilityTypesList || [];

        const formatted = list.map((item, index) => ({
          id: item.facilityTypeID || `ID-${index + 1}`,
          name: item.facilityTypeName || "",
          type: item.facilityType || "default",
          selected: !!item.activated,
          associatedProductTypes: item.associatedProductTypes.map(
            (product) => ({
              id: product.productTypeID,
              name: product.productTypeName,
            })
          ),
          lastUpdatedBy: item.lastUpdatedBy || "",
          isNew: false,
        }));

        setFacilityTypes(formatted); // Update the state with the fetched facility types
      } else {
        console.error("Failed to fetch facility types.");
        setError("Failed to fetch facility types. Please try again.");
      }
    } catch (error) {
      console.error("Error fetching facility types:", error);
      setError(
        "An error occurred while fetching facility types. Please try again."
      );
    } finally {
      setLoading(false); // Hide loading indicator
    }
  };

  useEffect(() => {
    fetchFacilityTypes();
  }, []);

  const fetchProductOptions = async () => {
    try {
      const url = `${networkUrl}/Pharma%20Contract%20Manufacturing/${network}/Pharma%20Co/Admin/fetchProductTypes/false`;
      const response = await axios.get(url);
      const data = response?.data?.data;


      if (data?.status === true || data?.status === "true") {
        const options = data.productTypeList.map((item) => ({
          id: item.productTypeID,
          name: item.productTypeName,
        }));
        setProductOptions(options); // Update the product options state
      } else {
        console.error("Failed to fetch product options.");
      }
    } catch (error) {
      console.error("Error fetching product options:", error);
    }
  };

  const handleSaveNewFacilityType = async (index) => {
    // Prevent duplicate saves if already saving
    if (savingStates[index]) return;
    setSavingStates((prev) => ({ ...prev, [index]: true }));
    const facilityType = facilityTypes[index]; // Get the facility type at the specified index
    try {
      // Prepare the payload for the API
      const payload = {
         ecosystemId:addSponsorList?.data?.ecosystemId || rowData?.ecosystemId,
      sponsorId: addSponsorList?.data?.organizationId || rowData?.organizationId,
        facilityTypesList: [
          {
            facilityTypeName: facilityType.name, // Facility type name
            facilityType: "New", // Facility type (default if not provided)
            activated: facilityType.selected, // Activation status
            associatedProductTypesList: facilityType?.products?.map(
              (product) => ({
                productTypeName: product?.name, // Product type name
                productTypeID: product?.id, // Product type ID
              })
            ),
          },
        ],
      };


      // Call the API to save the facility type
      const url = `${networkUrl}/Pharma%20Contract%20Manufacturing/${network}/Pharma%20Co/Admin/addFacilityTypes`;
      const response = await axios.post(url, payload);

      if (response.data?.status === true) {
        props.setManufacturingFacilityType((prev) => !prev);
        // Update the state to mark the row as saved
        setFacilityTypes((prev) =>
          prev?.map((row, i) =>
            i === index
              ? { ...row, id: response.data?.data?.id, isNew: false }
              : row
          )
        );

        await fetchFacilityTypes(); // Refresh the facility types list
      } else {
        console.error("Failed to save facility type:", response.data?.message);
      }
    } catch (error) {
      console.error("Error saving facility type:", error);
    }
    setSavingStates((prev) => ({ ...prev, [index]: false }));
  };

  const handleDelete = async (index) => {
    const facilityType = facilityTypes[index];
    if (facilityType.isNew) {
      setFacilityTypes((prev) => prev.filter((_, i) => i !== index)); // Remove the row from the state
      return;
    } // Get the facility type at the specified index
    // if (isUpdated) {
      try {
        // Prepare the payload for the API
        const payload = {
          ecosystemId:addSponsorList?.data?.ecosystemId || rowData?.ecosystemId,
      sponsorId: addSponsorList?.data?.organizationId || rowData?.organizationId,
          facilityTypesList: [
            {
              facilityTypeName: facilityType.name, // Facility type name
              facilityTypeID: facilityType.id, // Facility type ID
              activated: facilityType.selected, // Activation status
              associatedProductTypesList:
                facilityType?.associatedProductTypes?.map((product) => ({
                  productTypeName: product?.name, // Product type name
                  productTypeID: product?.id, // Product type ID
                })),
              markForDelete: true, // Mark this facility type for deletion
            },
          ],
        };


        // Call the API to delete the facility type
        const url = `${networkUrl}/Pharma%20Contract%20Manufacturing/${network}/Pharma%20Co/Admin/updateFacilityTypes`;
        const response = await axios.post(url, payload);

        await fetchFacilityTypes();
        if (
          response.data?.status === true ||
          response.data?.status === "true"
        ) {
          props.setManufacturingFacilityType((prev) => !prev);
          // Remove the facility type from the state
          setFacilityTypes((prev) => prev.filter((_, i) => i !== index));
        } else {
          console.error(
            "Failed to delete facility type:",
            response.data?.message
          );
        }
      } catch (error) {
        console.error("Error deleting facility type:", error);
      }
    // } 
    // else {
    //   // If not updated, just remove from state
    //   setFacilityTypes((prev) => prev.filter((_, i) => i !== index));
    // }
  };

  const handleNextClick = async () => {
    try {
      // Check if at least one toggle is turned on
      const isAnyToggleOn = facilityTypes.filter(
        (facility) => facility.isUpdated
      );
      if (!isAnyToggleOn.length) {
        props.handleNext(); // Directly move to the next tab
        return;
      }

      // if (!isAnyToggleOn.length) {
      //   setErrorMessage(
      //     "Please activate at least one Manufacturing Facility Type."
      //   ); // Show error message
      //   return; // Exit the function
      // }
      if (facilityTypes.every((facility) => !facility.selected)) {
        setErrorMessage("Please enable at least one in toggle mode.");
        return;
      }

      setIsSaving(true); // Start loading

      // Prepare the payload for the API - include all facility types
      const payload = {
        ecosystemId:addSponsorList?.data?.ecosystemId || rowData?.ecosystemId,
      sponsorId: addSponsorList?.data?.organizationId || rowData?.organizationId,
        facilityTypesList: isAnyToggleOn.map((facility) => ({
          facilityTypeName: facility.name,
          facilityTypeID: facility.id,
          activated: facility.selected,
          associatedProductTypesList: facility?.associatedProductTypes?.map(
            (product) => ({
              productTypeName: product?.name || "Unknown",
              productTypeID: product?.id || null,
            })
          ),
        })),
      };


      // Call the API to update the facility types
      const url = `${networkUrl}/Pharma%20Contract%20Manufacturing/${network}/Pharma%20Co/Admin/updateFacilityTypes`;
      const response = await axios.post(url, payload);
      await fetchFacilityTypes();
      if (response.data?.status === true || response.data?.status === "true") {

        // Move to the next tab
        props.handleNext();
      } else {
        console.error(
          "Failed to update facility types:",
          response.data?.message
        );
        setErrorMessage(
          response.data?.message || "Failed to update facility types."
        );
      }
    } catch (error) {
      console.error("Error updating facility types:", error);
      setErrorMessage("An error occurred while updating the facility types.");
    } finally {
      setIsSaving(false); // Stop loading
    }
  };

  const handleToggle = (index) => {
    setFacilityTypes((prev) =>
      prev.map((facility, i) =>
        i === index
          ? { ...facility, selected: !facility.selected, isUpdated: true }
          : facility
      )
    );
    setIsUpdated(true); // Mark as updated
  };

  const handleCancel = (index) => {
    setFacilityTypes((prev) => prev.filter((_, i) => i !== index));
  };

  const handleAddNew = () => {
    // const nextId = (facilityTypes.length + 1).toString().padStart(2, "0"); // Generate a unique ID
    setFacilityTypes([
      ...facilityTypes,
      {
        // id: nextId, // Use the generated ID
        name: "",
        products: [],
        selected: false,
        isNew: true,
      },
    ]);
    setIsUpdated(true);
  };

  const handleNameChange = (index, value) => {
    setFacilityTypes((prev) =>
      prev.map((facility, i) =>
        i === index ? { ...facility, name: value } : facility
      )
    );
    setIsUpdated(true); // Mark as updated
  };

  // Render component
  return (
    <div style={{ padding: 16 }}>
      <TableContainer component={Paper} className={classes.table}>
        <Table>
          <TableHead style={{ backgroundColor: "#f5f5f5" }}>
            <TableRow>
              <TableCell>
                <b>Selection</b>
              </TableCell>
              <TableCell>
                <b>Manufacturing Facility Type</b>
              </TableCell>
              <TableCell style={{whiteSpace: 'nowrap'}}>
                <b>Manufacturing Facility Type ID</b>
              </TableCell>
              <TableCell>
                <b>Associated Product Types</b>
              </TableCell>
              <TableCell>
                <b>Action</b>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={5}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100px",
                    }}
                  >
                    <CircularProgress />
                  </div>
                </TableCell>
              </TableRow>
            ) : error ? (
              <TableRow>
                <TableCell colSpan={5}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "60px",
                      backgroundColor: "#ffecec",
                      color: "#b00020",
                      border: "1px solid #ff9999",
                    }}
                  >
                    <Typography>{error}</Typography>
                  </div>
                </TableCell>
              </TableRow>
            ) : (
              facilityTypes.map((item, index) => (
                <TableRow key={item.id || `new-${index}`}>
                  <TableCell>
                    <Switch
                      checked={item.selected}
                      onChange={() => handleToggle(index)}
                    />
                  </TableCell>
                  <TableCell>
                    {item.isNew ? (
                      <TextField
                        value={item.name}
                        onChange={(e) =>
                          handleNameChange(index, e.target.value)
                        }
                        placeholder="Enter Facility Type Name"
                        size="small"
                        variant="outlined"
                        inputProps={{
                              onBeforeInput: (e) => {
                                const allowedChars = /^[a-zA-Z0-9\s\-.,&/()]+$/;
                                if (!allowedChars.test(e.data)) {
                                  e.preventDefault();
                                }
                              }
                            }}
                      />
                    ) : (
                      item.name
                    )}
                  </TableCell>
                  <TableCell>{item.id}</TableCell>
                  <TableCell>
                    {item.isNew ? (
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <Select
                          multiple
                          displayEmpty
                          value={
                            item.products
                              ? item.products.map((product) => product.id)
                              : []
                          } // Use IDs for the value
                          onChange={(e) => {
                            const selectedIds = e.target.value; // Array of selected IDs
                            const selectedProducts = productOptions.filter(
                              (option) => selectedIds.includes(option.id)
                            ); // Get the selected products (id and name)

                            setFacilityTypes((prev) =>
                              prev.map((row, i) =>
                                i === index
                                  ? { ...row, products: selectedProducts }
                                  : row
                              )
                            );
                            setIsUpdated(true);
                          }}
                          onOpen={fetchProductOptions} // Fetch product options when the dropdown is opened
                          renderValue={(selected) =>
                            selected.length > 0
                              ? selected
                                  .map(
                                    (id) =>
                                      productOptions.find(
                                        (option) => option.id === id
                                      )?.name
                                  )
                                  .join(", ")
                              : "Select from the list"
                          }
                          style={{ width: 200 }}
                          size="small"
                          variant="outlined"
                        >
                          {productOptions.map((option) => (
                            <MenuItem key={option.id} value={option.id}>
                              <Checkbox
                                checked={
                                  item.products
                                    ? item.products.some(
                                        (product) => product.id === option.id
                                      )
                                    : false
                                }
                              />
                              <ListItemText primary={option.name} />
                            </MenuItem>
                          ))}
                        </Select>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                          }}
                        >
                          <IconButton
                            onClick={() => handleCancel(index)}
                            className={classes.iconBtn}
                          >
                            <CancelIcon fontSize="small" />
                          </IconButton>
                          <IconButton
                            onClick={() => handleSaveNewFacilityType(index)}
                            className={classes.iconBtn}
                            disabled={
                              !facilityTypes[index].name?.trim() ||
                              facilityTypes.some(
                                (f, i) =>
                                  i !== index &&
                                  f.name?.trim().toLowerCase() === facilityTypes[index].name?.trim().toLowerCase()
                              ) || savingStates[index]
                            } 
                          >
                            <SaveIcon fontSize="small" />
                          </IconButton>
                        </div>
                      </div>
                    ) : (
                      // Array.isArray(item.associatedProductTypes) &&
                      // item.associatedProductTypes.map((product) => (
                      //   <Typography key={product.id}>{product.name}</Typography>
                      // ))
                      Array.isArray(item.associatedProductTypes) && (
                        <Typography component="span">
                          {item.associatedProductTypes.map((product, index) => (
                            <Typography key={product.id} component="span">
                              {product.name}
                              {index < item.associatedProductTypes.length - 1 &&
                                ", "}
                            </Typography>
                          ))}
                        </Typography>
                      )
                    )}
                  </TableCell>

                  <TableCell>
                    {(item.isNew === true || item.type !== "Default") && (
                      <IconButton
                        onClick={() => handleDelete(index)} // Handle delete for both new and existing rows
                        className={classes.deleteIcon}
                      >
                        <DeleteIcon />
                      </IconButton>
                    )}
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {errorMessage && (
        <div style={{ color: "red", marginTop: 10 }} className="error-message">
          {errorMessage}
        </div>
      )}
      <Button
        variant="outlined"
        className={classes.addButton}
        onClick={handleAddNew}
      >
        <span className={classes.addIconCircle}>+</span>
        Add New Manufacturing Facility Type
      </Button>

      <div className={classes.footerContainer}>
        <Grid
          className={classes.backButton}
          onClick={() => {
            props.handleBack();
          }}
        >
          <ChevronLeftIcon />
          Back
        </Grid>
        <div className={classes.footer}>
        <Grid
          className={classes.saveButton}
          onClick={() => {
            if (isUpdated) {
              handleNextClick(); // Call API and move to the next tab if updates are made
            } else {
              props.handleNext(); // Directly move to the next tab if no updates are made
            }
          }}
          style={{ 
            opacity: isSaving ? 0.7 : 1, 
            pointerEvents: isSaving ? 'none' : 'auto' 
          }}
        >
          {isSaving ? (
            <>
              <CircularProgress size={16} color="inherit" style={{ marginRight: '8px' }} />
              Saving...
            </>
          ) : (
            <>
              Save & Next
              <ChevronRightIcon />
            </>
          )}
        </Grid>
        </div>
      </div>
    </div>
  );
};

export default ManufacturingFacilityTypeTab;
